// pages/Home.jsx
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Home.css";
import MedicalBanner from "./MedicalBanner";
import MedicalBanner1 from "./MedicalBanner1";

// images
import Bolda from "./CarouselImages/Anabolics/Bolda.jpeg";
import CutMix from "./CarouselImages/Anabolics/CutMix.jpeg";
import GainBlend from "./CarouselImages/Anabolics/GainBlend.jpeg";
import Masterone from "./CarouselImages/Anabolics/Masterone.jpeg";
import Primobolan from "./CarouselImages/Anabolics/Primobolan.jpeg";
import TestC from "./CarouselImages/Anabolics/TestC.jpeg";
import TestP from "./CarouselImages/Anabolics/TestP.jpeg";
import TrenA from "./CarouselImages/Anabolics/TrenA.jpeg";
import TrenE from "./CarouselImages/Anabolics/TrenE.jpeg";
import TrenH from "./CarouselImages/Anabolics/TrenH.jpeg";
// import TriTren from "./CarouselImages/Anabolics/TriTren.jpeg";
import Winstrol from "./CarouselImages/Anabolics/Winstrol.jpeg";
import Cardarine from "./CarouselImages/sarms/Cardarine.jpg";
import LGD4033 from "./CarouselImages/sarms/LGD4033.jpg";
import MK677 from "./CarouselImages/sarms/MK677.jpg";
import MK2866 from "./CarouselImages/sarms/MK2866.jpg";
import RAD from "./CarouselImages/sarms/RAD.jpg";
import S23 from "./CarouselImages/sarms/S23.jpg";
import SR9009 from "./CarouselImages/sarms/SR9009.jpg";

const products = [
  { img: Bolda, title: "Bolda", desc: "$57" },
  { img: CutMix, title: "Cut Mix", desc: "$53" },
  { img: GainBlend, title: "Gain Blend", desc: "$62" },
  { img: Masterone, title: "Masterone", desc: "$66" },
  { img: Primobolan, title: "Primbolan", desc: "$55" },
  { img: TestC, title: "TEST-C", desc: "$76" },
  { img: TestP, title: "TEST-P", desc: "$79" },
  { img: TrenA, title: "Tren-A", desc: "$82" },
  { img: TrenE, title: "Tren-E", desc: "$54" },
  { img: TrenH, title: "Tren-H", desc: "$56" },
  // { img: TriTren, title: "Tri Tren", desc: "$63" },
  { img: Winstrol, title: "Winstrol", desc: "$67" },
  { img: Cardarine, title: "Cardarine", desc: "$79" },
  { img: LGD4033, title: "LGD-4033", desc: "$80" },
  { img: MK677, title: "MK-677", desc: "$58" },
  { img: MK2866, title: "MK-2866", desc: "$82" },
  { img: RAD, title: "RAD", desc: "$67" },
  { img: S23, title: "S-23", desc: "$81" },
  { img: SR9009, title: "SR-9009", desc: "$82" },
];

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    customPaging: () => <div className="custom-dot" />,
    appendDots: (dots) => (
      <div>
        <ul className="custom-dots">{dots.slice(0, 3)}</ul>
      </div>
    ),
  };

  return (
    <div className="home-container">
      <MedicalBanner />
      <MedicalBanner1 />

      <section className="product-carousel">
        <h2 className="carousel-title">Top Trending Products</h2>
        <Slider {...settings}>
          {products.map((product, index) => (
            <div className="carousel-card" key={index}>
              <img src={product.img} alt={`Product ${product.title}`} className="carousel-img" />
              <h3>{product.title}</h3>
              <p>{product.desc}</p>
            </div>
          ))}
        </Slider>
      </section>

      <section className="contact-cta">
        <h2>Have Questions?</h2>
        <p>Reach out to our team for any product or partnership inquiry.</p>
        <Link to="/contact" className="btn-primary">Contact Us</Link>
      </section>
    </div>
  );
};

export default Home;
